module.exports = __webpack_public_path__ + "media/lobby_normal5.b06e0f49.mp3";